import { selector } from 'recoil';
import { aggregatorService } from '../../services/aggregator';

export const labelsAtom = selector({
	key: `vinCheckerLabels`,
	get: async () => {
		try {
			return await aggregatorService.fetchLabels();
		} catch (err) {
			console.error(err);
			return {};
		}
	}
});
